import React from "react";

import Paper from "@material-ui/core/Paper";
import TablePagination from "@mui/material/TablePagination";

import jwtInterceptor from "../service/jwtInterceptor";
import TableRowUser from "../component/TableRowUser";
import {API_URL} from "../utils/constants";
import {Helmet} from "react-helmet";
import CustomBtn from "../component/customBtns/CustomBtn";
import {Box, Button} from "@mui/material";
import Modal from "@mui/material/Modal";
import {InscriptionUser} from "../component/users/InscriptionUser";
import UserFilter from "../component/UserFilter";


const PRIMARY_COLOR = "#3F50B6";
const SECONDARY_COLOR = "#000000";

class UserContainer extends React.Component {
    DEFAULT_PER_PAGE = 10;
    DEFAULT_PAGE = 0;

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            dataTable: [],
            page: this.DEFAULT_PAGE,
            rowsPerPage: this.DEFAULT_PER_PAGE,
            openCreateCollaboModal: false,
            selectedUser: null,
            userSearch: "",
        };
    }

    handleEditUser = (user) => {

        this.setState({
            selectedUser: user,
            openCreateCollaboModal: true,
        }, () => {
            console.log('État après mise à jour:', this.state.selectedUser);
        });
    };


    setOpenCreateCollaboModal = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            openCreateCollaboModal: value,
        }));
    };
    colums = [
        {accessor: "active", show: "Actif"},
        {accessor: "username", show: "Pseudo"},
        {accessor: "name", show: "Nom"},
        {accessor: "firstname", show: "Prénom(s)"},
        {accessor: "userType", show: "Type"},
        {accessor: "email", show: "E-mail"},
        {accessor: "createdAt", show: "Date inscription"},
    ];
    handleChangePage = (event, newPage) => {
        this.setState((prevState) => {
            return {...prevState, page: newPage};
        });
        this.getData(this.state.rowsPerPage, newPage);
    };

    handleChangeRowsPerPage = (event) => {
        this.setState((prevState) => {
            return {...prevState, rowsPerPage: parseInt(event.target.value)};
        });
        this.getData(event.target.value, this.state.page);
    };

    getData = (perPage, page) => {
        this.searchfn({
            size: perPage,
            page: page,
            name: this.state.userSearch,
        });
    };

    handleUserSearch = (name) => {
        this.setState({userSearch: name, page: this.DEFAULT_PAGE}, () => {
            this.getData(this.state.rowsPerPage, this.DEFAULT_PAGE);
        });
    };

    componentDidMount() {
        this.getData(this.DEFAULT_PER_PAGE, this.DEFAULT_PAGE);
    }

    searchfn = (filter) => {
        const search = filter.name ? `&name=${encodeURIComponent(filter.name)}` : "";
        jwtInterceptor
            .get(
                `${API_URL}/user?size=${filter.size}&page=${filter.page}${search}`
            )
            .then((res) => {
                const result = res.data?.data?.details || res.data?.data || {};
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        total: result.totalCount || result.total || 0,
                        dataTable: result.records || result.results || [],
                    };
                });
            })
            .catch(() => {
                this.setState({total: 0, dataTable: []});
            });
    };

    onClickCreateUser($event) {
        $event.target.stopPropagation();
        this.setOpenCreateCollaboModal(true);
    }


    onCloseCreateUser = () => {
        this.setState({
            openCreateCollaboModal: false,
            selectedUser: null,
        });
        this.getData(this.DEFAULT_PER_PAGE, this.DEFAULT_PAGE);
    };

    render() {
        /****Custom variable styles */
        const fontWeightTitle = {
            fontWeight: "600",
        };
        return (
            <div className="my-4 px-4">
                <Helmet>
                    <title>Gérer les utilisateurs - Mixdata</title>
                </Helmet>
                <div className="d-flex justify-content-between">
                    <h3
                        className="mb-4"
                        style={{...fontWeightTitle, width: "fit-content"}}
                    >
                        Utilisateurs
                    </h3>
                    <div className="d-flex align-items-center gap-3" style={{width: "fit-content"}}>
                        <Button
                            variant="contained"
                            onClick={() => this.setOpenCreateCollaboModal(true)}
                            sx={{ backgroundColor: PRIMARY_COLOR, "&:hover": { backgroundColor: "#9e9e9e" } }}
                        >
                            Ajouter un Utilisateur
                        </Button>
                        {/* <Image src={FilterIcon} className="fluid ms-3 pointer"></Image> */}
                    </div>
                </div>
                <Paper className="py-4 px-4 rounded shadow-none App-container sw-100 m-0">
                    <Box sx={{ mb: 2, maxWidth: 360 }}>
                        <UserFilter value={this.state.userSearch} onChange={this.handleUserSearch}/>
                    </Box>

                    <div className="overflow-auto">
                        <table className="table" style={{margin: "auto"}}>
                            <thead
                                style={{
                                    background: "#eeeeee",
                                    borderBottom: "2px #DEE2E6 solid",
                                    fontWeight: "normal",
                                    color: "#363636",
                                    marginBottom: "5px",
                                }}
                            >
                            <tr>
                                {this.colums.map((field) => {
                                    return (
                                        <th
                                            scope="col"
                                            key={field.accessor}
                                        >
                                            {field.show}
                                        </th>
                                    );
                                })}
                                <th  scope="col" key={"actions"}>
                                    Action
                                </th>
                            </tr>
                            </thead>
                            <tbody style={{paddingInline: "5px"}}>
                            {this.state.dataTable.map((row, index) => (
                                <TableRowUser
                                    key={row._source?.id || row.id || row._id}
                                    keyIndex={index}
                                    row={row}
                                    onEdit={() => this.handleEditUser(row)}
                                    onDeleted={() => this.getData(this.state.rowsPerPage, this.state.page)}
                                />
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <TablePagination
                        component="div"
                        count={this.state.total}
                        page={
                            !this.state.page || this.state.page <= 0 ? 0 : this.state.page
                        }
                        onPageChange={this.handleChangePage}
                        rowsPerPage={this.state.rowsPerPage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                        labelRowsPerPage="Lignes par page"
                        backIconButtonProps={{
                            "aria-label": "Précédent",
                            className: "PreviousBtn",
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Suivant",
                            className: "NextBtn",
                        }}
                    />
                    <Modal
                        open={this.state.openCreateCollaboModal}
                        onClose={this.onCloseCreateUser}
                        sx={{zIndex: 1200}}
                    >
                        <Box
                            className="w-50 h-auto rounded p-3"
                            style={{height: "fit-content"}}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                p: 4,
                            }}
                        >
                            <InscriptionUser
                                onSubmitted={this.onCloseCreateUser}
                                userToEdit={this.state.selectedUser}
                            ></InscriptionUser>
                        </Box>
                    </Modal>
                </Paper>

            </div>
        );
    }
}

export default UserContainer;
